import { Nullable } from 'global';
import moment from 'moment/moment';
import { DiscountType, QuoteAftermarketProductType, QuoteFeeType } from '@trnsact/trnsact-shared-types';
import { Quote, QuoteFormValues } from '../types';

type QuoteFieldWithEquipmentId = keyof Pick<
  Quote,
  'fees' | 'rebates' | 'cashBackAmounts' | 'equipmentTradeIns' | 'aftermarketProducts'
>;

export const fieldsToFilter: QuoteFieldWithEquipmentId[] = [
  'fees',
  'rebates',
  'cashBackAmounts',
  'equipmentTradeIns',
  'aftermarketProducts',
];

export const createInitialQuoteFormValue = (equipmentId: Nullable<string> = null): QuoteFormValues => {
  const initialFees = Object.values(QuoteFeeType)
    .filter(type => type !== QuoteFeeType.Other)
    .map(type => ({ type, amount: 0, equipmentId, description: '' }));

  const initialAftermarketProducts = Object.values(QuoteAftermarketProductType)
    .filter(type => type !== QuoteAftermarketProductType.Other)
    .map(type => ({ type, cost: 0, equipmentId, description: '' }));

  return {
    fees: initialFees,
    term: null,
    rebates: [],
    equipment: [],
    attributes: [],
    downPayment: 0,
    interestRate: 0,
    paymentAmount: 0,
    cashBackAmounts: [],
    equipmentTradeIns: [],
    contractStartDate: moment().toISOString(),
    firstPaymentDueDate: moment().toISOString(),
    aftermarketProducts: initialAftermarketProducts,
  };
};

export const chargeTypeOptions = [
  { label: '$', value: DiscountType.Flat },
  { label: '%', value: DiscountType.Percent },
];

export const CHARGE_ROW_HEIGHT = '82px';
